// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"243":"ContentPage","468":"LeadPage"}[chunkId] + "." + {"243":"ba346e79","468":"ba346e79"}[chunkId] + ".chunk.css";
};